import { Machine, MachineConfig, assign } from 'xstate'

export enum OnboardingStateMachineV1Enum {
  WorkEmail = 'workEmail',
  WorkEmailVerification = 'WorkEmailVerification',
  OrganizationName = 'organizationName',
  Address = 'address',
  Publish = 'publish',
  CompanyExists = 'companyExists',
}

interface OnboardingSchema {
  states: {
    [OnboardingStateMachineV1Enum.WorkEmail]: {}
    [OnboardingStateMachineV1Enum.WorkEmailVerification]: {}
    [OnboardingStateMachineV1Enum.OrganizationName]: {}
    [OnboardingStateMachineV1Enum.Address]: {}
    [OnboardingStateMachineV1Enum.Publish]: {}
    [OnboardingStateMachineV1Enum.CompanyExists]: {}
  }
}

export interface OnboardingContext {
  emailAddress: string
  emailToken: string
  exchangeToken: string
  organizationName: string
  firstWorkspaceLocation: google.maps.places.PlaceResult | undefined
  formattedAddress: string | undefined
}

export type OnboardingEvent =
  | { type: 'NEXT' }
  | { type: 'COMPANY_EXISTS' }
  | { type: 'UPDATE_CONTEXT' }
  | { type: 'VERIFIED' }

const onboardingStateMachineConfig: MachineConfig<
  OnboardingContext,
  OnboardingSchema,
  OnboardingEvent
> = {
  id: 'onboardingV1',
  initial: OnboardingStateMachineV1Enum.WorkEmail,
  context: {
    emailAddress: '',
    emailToken: '',
    exchangeToken: '',
    organizationName: '',
    firstWorkspaceLocation: undefined,
    formattedAddress: '',
  },
  on: {
    UPDATE_CONTEXT: {
      actions: assign({
        emailAddress: (_, event: any) => event.email,
        exchangeToken: (_, event: any) => event.exchangeToken,
        emailToken: (_, event: any) => event.emailToken,
        firstWorkspaceLocation: (_, event: any) => event.firstWorkspaceLocation,
        organizationName: (_, event: any) => event.organizationName,
        formattedAddress: (_, event: any) => event.formattedAddress,
      }),
    },
  },
  states: {
    [OnboardingStateMachineV1Enum.WorkEmail]: {
      on: {
        NEXT: {
          target: OnboardingStateMachineV1Enum.WorkEmailVerification,
          actions: assign({
            emailAddress: (_, event: any) => event.email,
            emailToken: (_, event: any) => event.emailToken,
            exchangeToken: (_, event: any) => event.exchangeToken,
          }),
        },
        COMPANY_EXISTS: OnboardingStateMachineV1Enum.CompanyExists,
        VERIFIED: {
          target: OnboardingStateMachineV1Enum.OrganizationName,
          actions: assign({
            emailToken: (_, event: any) => event.emailToken,
          }),
        },
      },
    },
    [OnboardingStateMachineV1Enum.WorkEmailVerification]: {
      on: {
        NEXT: {
          target: OnboardingStateMachineV1Enum.OrganizationName,
          actions: assign({
            emailToken: (_, event: any) => event.emailToken,
          }),
        },
        COMPANY_EXISTS: OnboardingStateMachineV1Enum.CompanyExists,
      },
    },
    [OnboardingStateMachineV1Enum.OrganizationName]: {
      on: {
        NEXT: {
          target: OnboardingStateMachineV1Enum.Address,
          actions: assign({
            organizationName: (_, event: any) => event.organizationName,
          }),
        },
        COMPANY_EXISTS: OnboardingStateMachineV1Enum.CompanyExists,
      },
    },
    [OnboardingStateMachineV1Enum.Address]: {
      on: {
        NEXT: {
          target: OnboardingStateMachineV1Enum.Publish,
          actions: assign({
            firstWorkspaceLocation: (_, event: any) =>
              event.firstWorkspaceLocation,
          }),
        },
        COMPANY_EXISTS: OnboardingStateMachineV1Enum.CompanyExists,
      },
    },
    [OnboardingStateMachineV1Enum.Publish]: {
      entry: 'goToPublish',
      type: 'final',
    },
    companyExists: {
      type: 'final',
    },
  },
}

export default Machine(onboardingStateMachineConfig, {})
